import { navigate } from "gatsby";
import { useEffect } from "react";
import { useInviterName } from "../../hooks/sharing.hooks";
import "./sharing-referral.scss";
import {
  extractBrokerReferralFromUrl,
  extractUserReferralFromUrl,
  getCurrentLocation,
} from "../../utils/get-params-value";
import { LoadingBackdrop } from "../loading-backdrop";

const SharingLayout = () => {
  const location = getCurrentLocation();
  const [referralPath, referralCode] = extractUserReferralFromUrl(location.pathname);

  const { data: { staffCode: staffCodeFromUser = "" } = {}, isLoading } = useInviterName(
    referralPath,
    referralCode
  );

  const [, staffCodeFromUrl] = extractBrokerReferralFromUrl(location.pathname);
  const staffCode = staffCodeFromUrl || staffCodeFromUser;

  useEffect(() => {
    if (!isLoading) {
      if (staffCode) {
        navigate(`/signup?staffCode=${staffCode}`);
      } else {
        navigate("/signup");
      }
    }
  }, [isLoading]);

  if (isLoading) {
    return <LoadingBackdrop />;
  }

  return <LoadingBackdrop />;
};

SharingLayout.propTypes = {};

export default SharingLayout;
